import axios, { AxiosPromise } from 'axios';

import { IRegion } from '../../../@types/model/masterData/region/region';

export default class RegionHttpService {
    public static getRegionData() : AxiosPromise<Array<IRegion>> {
        return axios.get(`${API_URL}/v1/Region/GetAllWeb`);
    }

    public static addOrUpdateRegion(data : IRegion) : AxiosPromise<IRegion> {
        return axios.post(`${API_URL}/v1/Region/PostRegion`, data);
    }

    public static deleteRegion(regionId : number) : AxiosPromise<IRegion> {
        return axios.delete(`${API_URL}/v1/Region/Delete`, {
            params : { regionId },
        });
    }
}
